var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import isEmpty from 'lodash.isempty';
import { useContext, useEffect, useState } from 'react';
import { useQuery } from '../../../abstractions/hooks/useQuery';
import { PreloadsContext } from '../../../contexts/preloads';
import { FactoryComponent } from '../../../factory';
import useDesign from '../../../hooks/useDesign';
import { GenericComponent } from '../../atoms/GenericComponent';
import { SelectTagOption } from './components/SelectTagOption';
function Placeholder(_a) {
    var design = _a.design, _b = _a.length, length = _b === void 0 ? 3 : _b;
    var schema = useDesign(design).schema;
    var items = Array.from({ length: length });
    return (_jsx(_Fragment, { children: items.map(function (_, index) { return (_jsx(GenericComponent, { isLoading: true, schema: schema }, "tag-placeholder-".concat(index))); }) }));
}
function getNextSelectedValues(_a) {
    var selectedValues = _a.selectedValues, value = _a.value;
    var index = selectedValues.findIndex(function (selectedValue) { return selectedValue === value; });
    if (index > -1) {
        var nextSelectedValues = __spreadArray([], selectedValues, true);
        nextSelectedValues.splice(index, 1);
        return nextSelectedValues;
    }
    return selectedValues.concat(value);
}
function fetchOptionsIfNeeded(_a) {
    var options = _a.options, _b = _a.optionsFetchConfig, _c = _b === void 0 ? {} : _b, url = _c.url, opts = _c.opts, optionsFetchHandler = _a.optionsFetchHandler;
    if (!isEmpty(options))
        return options;
    if (optionsFetchHandler)
        return optionsFetchHandler({ url: url, opts: opts });
    if (!isEmpty(url)) {
        return fetch(url, opts).then(function (res) {
            if (!res.ok) {
                console.error('Something went wrong fetching options on Select component.');
                return Promise.resolve({});
            }
            return res.json();
        }, function (e) {
            console.error('Something went wrong fetching options on Select component.', e);
            return Promise.resolve({});
        });
    }
    return Promise.resolve({});
}
export var SelectTagsComponent = function (_a) {
    var design = _a.design, selected = _a.selected, options = _a.options, optionsFetchConfig = _a.optionsFetchConfig, optionsFetchHandler = _a.optionsFetchHandler, onChange = _a.onChange, className = _a.className, isFetching = _a.isFetching;
    var _b = useDesign(design), components = _b.components, config = _b.config, schema = _b.schema;
    var _c = useState(selected || (config === null || config === void 0 ? void 0 : config.defaultValue)), selectedValues = _c[0], setSelectedValues = _c[1];
    var _d = useQuery(['selectOptions', options], function () {
        return fetchOptionsIfNeeded(__assign({ options: options, optionsFetchHandler: optionsFetchHandler, optionsFetchConfig: optionsFetchConfig }, config));
    }, {
        refetchOnWindowFocus: false,
        staleTime: Infinity,
        refetchOnMount: false,
    }), isLoading = _d.isLoading, _e = _d.data, data = _e === void 0 ? {} : _e;
    // Propagate "selectedValues" local state change to parent
    var handleSelectTag = function (value) { return function () {
        var nextSelectedValues = getNextSelectedValues({ selectedValues: selectedValues, value: value });
        onChange === null || onChange === void 0 ? void 0 : onChange(nextSelectedValues);
        setSelectedValues(nextSelectedValues);
    }; };
    // Consume "selected" prop change from parent to set local "selectedValues"
    useEffect(function () {
        if (selected && selected !== selectedValues) {
            setSelectedValues(selected);
        }
    }, [selected, selectedValues]);
    return (_jsx(FactoryComponent, __assign({ className: className, schema: schema }, { children: isLoading || isFetching ? (_jsx(Placeholder, { isLoading: true, design: components.option, length: config.length })) : (Object.values(data).map(function (_a) {
            var value = _a.value, i18n = _a.i18n;
            return (_jsx(SelectTagOption, { design: components.option, i18n: i18n, active: selectedValues.includes(value), onSelectTagOption: handleSelectTag(value) }, "".concat(design, ".").concat(value)));
        })) })));
};
export var PreloadedSelect = function (_a) {
    var design = _a.design, preload = _a.preload, props = __rest(_a, ["design", "preload"]);
    var preloads = useContext(PreloadsContext).preloads;
    var options = preloads[preload];
    return (_jsx(SelectTagsComponent, __assign({ design: design, isFetching: isEmpty(options), options: options }, props)));
};
export var SelectTags = function (_a) {
    var design = _a.design, value = _a.value, props = __rest(_a, ["design", "value"]);
    var _b = useDesign(design).config, config = _b === void 0 ? {} : _b;
    var preload = config.preload || props.preload;
    if (preload) {
        return _jsx(PreloadedSelect, __assign({ selected: value, preload: preload, design: design }, props));
    }
    return _jsx(SelectTagsComponent, __assign({ selected: value, design: design }, props));
};
SelectTags.displayName = 'SelectTags';
